export const FLAGS = Object.freeze({
  FLOW_GENERATE: false,
})
